module.exports = __webpack_public_path__ + "img/image-jpg.395313c4.png";